import { Person } from '../redux/reducers/clients'
import { Cpty } from '../redux/reducers/cpty'
import { CodeList } from '../types/common'

export const codeListToArrowSelect = (code: string, codeLists?: CodeList[]) => {
  const codeList = codeLists?.find(cl => cl.code === code) || { items: [] }
  return codeList?.items.map((item: any) => ({ label: item.code, value: item.code }))
}

export const codeListCodeItems = (code: string, codeLists?: CodeList[]) => {
  const codeList = codeLists?.find(cl => cl.code === code) || { items: [] }
  return codeList?.items.map((item: any) => item.code)
}

export const codeListCodeAndDescriptionItems = (code: string, codeLists?: CodeList[]) => {
  const codeList = codeLists?.find(cl => cl.code === code) || { items: [] }
  return codeList?.items.map((item: any) => ({ code: item.code, description: item.description }))
}

export const cptyListToArrowSelect = (cpty: Cpty[]) => {
  return cpty.map((item: any) => ({ label: item.name, value: item.name }))
}

export const personsItems = (persons: Person[]) => {
  return persons.map((item: any) => item.firstName + ' ' + item.surname)
}
